import { render, staticRenderFns } from "./AliveGame.vue?vue&type=template&id=cd150df8&scoped=true&"
import script from "./AliveGame.vue?vue&type=script&lang=js&"
export * from "./AliveGame.vue?vue&type=script&lang=js&"
import style0 from "./AliveGame.vue?vue&type=style&index=0&id=cd150df8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd150df8",
  null
  
)

export default component.exports